import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Search, Trash2, Shield, RefreshCw, Eye } from 'lucide-react';
import { AdminRideDetailModal } from './AdminRideDetailModal';

export const AdminRidesTab = ({ rides, searchTerm, setSearchTerm, handleDeleteRide, loadDashboardData }) => {
  const { t } = useTranslation();
  const [selectedRide, setSelectedRide] = useState(null);

  const filteredRides = rides.filter(ride => {
    if (!ride) return false;
    const search = searchTerm.toLowerCase();
    return (
      (ride.start_city?.toLowerCase().includes(search) || '') ||
      (ride.destination_city?.toLowerCase().includes(search) || '') ||
      (ride.end_city?.toLowerCase().includes(search) || '')
    );
  });

  return (
    <div className="rides-content" data-testid="admin-rides-tab">
      <div className="section-header">
        <h3>{t('admin.rides.management')}</h3>
        <div className="header-actions">
          <div className="search-bar">
            <Search size={20} />
            <input type="text" placeholder={t('admin.rides.search')} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
          </div>
        </div>
      </div>
      
      {rides.length === 0 ? (
        <div className="empty-state">
          <p>{t('admin.rides.noRidesFound')}</p>
          <button onClick={loadDashboardData} className="btn-primary"><RefreshCw size={16} /> {t('admin.actions.reload')}</button>
        </div>
      ) : (
        <div className="rides-table">
          <table>
            <thead>
              <tr>
                <th>{t('admin.rides.from')}</th>
                <th>{t('admin.rides.to')}</th>
                <th>{t('admin.rides.dateTime')}</th>
                <th>{t('admin.rides.driver')}</th>
                <th>{t('admin.rides.seats')}</th>
                <th>{t('admin.rides.price')}</th>
                <th>{t('admin.rides.status')}</th>
                <th>{t('admin.users.actions')}</th>
              </tr>
            </thead>
            <tbody>
              {filteredRides.map((ride) => (
                <tr
                  key={ride.ride_id || ride.id}
                  onClick={() => setSelectedRide(ride)}
                  style={{ cursor: 'pointer' }}
                  data-testid={`ride-row-${ride.ride_id || ride.id}`}
                >
                  <td>{ride.start_city || '-'}</td>
                  <td>{ride.destination_city || ride.end_city || '-'}</td>
                  <td>{ride.departure_date || '-'} <br/><small>{ride.departure_time || '-'}</small></td>
                  <td>
                    {ride.driver ? `${ride.driver.name || ''}` : (ride.driver_name || t('admin.rides.unknown'))}
                    {ride.driver?.verified && <Shield size={12} title={t('admin.users.verified')} style={{ marginLeft: 4 }} />}
                  </td>
                  <td><span className={`seats ${ride.seats_available === 0 ? 'full' : ''}`}>{ride.seats_available ?? 0}/{ride.seats_total ?? 0}</span></td>
                  <td>{ride.price_per_seat || 0}&#8364;</td>
                  <td>
                    <span className={`status-badge ${ride.status}`}>
                      {ride.status === 'available' ? t('admin.rides.statusActive') : 
                       ride.status === 'completed' ? t('admin.rides.statusCompleted') : 
                       ride.status === 'cancelled' ? t('admin.rides.statusCancelled') : 
                       ride.status || t('common.unknown')}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons" onClick={(e) => e.stopPropagation()}>
                      <button
                        className="action-button edit"
                        onClick={() => setSelectedRide(ride)}
                        title={t('admin.rides.details')}
                        data-testid={`view-ride-${ride.ride_id || ride.id}`}
                      >
                        <Eye size={16} />
                      </button>
                      <button className="action-button delete" onClick={() => handleDeleteRide(ride.ride_id || ride.id)} title={t('admin.rides.delete')}>
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {selectedRide && (
        <AdminRideDetailModal
          ride={selectedRide}
          onClose={() => setSelectedRide(null)}
        />
      )}
    </div>
  );
};
